import {useMemo} from 'react';
import {ViewStyle, TextStyle, ImageStyle} from 'react-native';
import {useSelector} from 'react-redux';
import {themeSelector} from '../../redux/selectors/runtime/theme';
import {VisImpFontSize} from '../models/visuallyImpairedSettings';
import {Theme, ThemeSettings} from './interface';
import {useDimensions} from '../hooks/useDimensions';

export enum DeviceSize {
  mobile = 0,
  tablet = 576,
  desktop = 992,
}

const mobileMockupWidth = 360;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
type Style = ViewStyle | TextStyle | ImageStyle;

export const useDeviceSize = (): DeviceSize => {
  const {width} = useDimensions();

  return useMemo(
    () => [DeviceSize.desktop, DeviceSize.tablet, DeviceSize.mobile].find((x) => x < width) || DeviceSize.mobile,
    [width],
  );
};

export type AlignFunc = (source: number) => number;
export type ThemeFunc = (align: AlignFunc, themeSettings: ThemeSettings, deviceSize: DeviceSize) => Theme;

export const maxDesktopContentWidth = 1420;
export const maxDesktopContentFooterWidth = 1420;
export const desktopMenuHeight = 147;
export const desktopCollapsedMenuHeight = 87;

export const useAlign = (): AlignFunc => {
  const {width} = useDimensions();

  const align: AlignFunc = useMemo(() => {
    if (width < DeviceSize.tablet) {
      return (source: number) => (source * width) / mobileMockupWidth;
    }

    return (source: number) => source;
  }, [width]);

  return align;
};

export const getFontSizeFactor = (visuallyImpairedActive: boolean, size: VisImpFontSize) => {
  if (!visuallyImpairedActive) {
    return 1;
  }
  switch (size) {
    case VisImpFontSize.Small:
      return 1;
    case VisImpFontSize.Medium:
      return 1.2;
    case VisImpFontSize.Large:
      return 1.4;
  }
};

export const useFontSizeFactor = () => {
  const {visuallyImpaired, fontSize} = useSelector(themeSelector());
  return getFontSizeFactor(!!visuallyImpaired, fontSize);
};
